import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { show_popup } from '@shared/utility/popup-error';

import swal from 'sweetalert2';
import { AuthService } from '../auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status == 401) {
          if (this.authService.isAuthenticated()) {
            this.authService.logout();
          }
          show_popup('', 'Tu sesión expiró');
        } else if (err.status == 403) {
          swal.fire('Acceso denegado', `${this.authService.user.name} no tienes acceso a este recurso`, 'warning');
        }
        return throwError(err);
      })
    );
  }
}
